import { Vue, i18n } from "Components/vue"
import Product from 'Components/vue/Product/Product.vue'

import { initRatingForm, buildStars } from 'Functions/rating';
import { formatPrice } from "FrontendJsAssets/common/format";

import 'Layouts/default';

import 'Ui/slider';
import 'Ui/tabs';
import 'Ui/more-items';
import 'Ui/favorite-trigger';
import 'Ui/collapsible-content';

import 'Common/lightgallery';
import { initAnchors, scrollToEl } from 'Functions/anchor';

import 'Components/seen-products';
import { checkResolution, dynamicEventListener } from "Functions/helpers";

import './product-jquery';
import { AsyncImageUpload } from "Components/async-image-upload";

const lang = document.querySelector('html').getAttribute('lang')
let localeTexts

import(`../../locale/${lang}`).then((module) => {
    localeTexts = module.Product
})

initRatingForm()

function showVueErrorOnVariationsPlaceholder(message) {
    const productInlineTemplate = document.querySelector('product[inline-template]')
    const placeholderEl = productInlineTemplate.querySelector('.js-product-variations-placeholder');

    placeholderEl.classList.remove('is-loading')
    placeholderEl.classList.add('has-error')

    Eshop.tippyAlert(placeholderEl, message, {
        theme: 'error',
        trigger: 'manual',
        hideOnClick: false,
    }, 9e9);
}

async function initializeVueProduct({
    productId,
    firstVariationId,
}) {
    const queryParams = new URLSearchParams()
    let response

    if (firstVariationId) {
        queryParams.append('variation', firstVariationId)
    }

    // if current url contains `preview` query param, add it to the request
    if (window.location.search.includes('preview')) {
        queryParams.append('preview', '1')
    }

    try {
        response = await fetch('/product-map/' + productId + '?' + queryParams.toString(), {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                }
            })

        if (!response.ok) {
            throw new Error(`${response.status} - ${response.statusText}`)
        }

        response = await response.json()

        if (!response.status) {
            console.error(response.message)

            showVueErrorOnVariationsPlaceholder(response.message)

            return
        }
    } catch (error) {
        console.error(error)

        showVueErrorOnVariationsPlaceholder(error)

        return
    }

    window.productData = response.data

    const productInlineTemplate = document.querySelector('product[inline-template]')

    productInlineTemplate.setAttribute(':initial-data', JSON.stringify(response.data) )

    new Vue({
        el: document.querySelector('product[inline-template]'),
        i18n,
        components: {
            Product
        }
    })
}

if (document.querySelector('product[inline-template]')) {
    initializeVueProduct(document.querySelector('product[inline-template]').dataset)
}

initAnchors()

let isFullscreenActive = false;
let fullscreenTimeout = null;

document.addEventListener('fullscreenchange', () => {
    if (document.fullscreenElement) {
        isFullscreenActive = true;
        clearTimeout(fullscreenTimeout);
    } else {
        fullscreenTimeout = setTimeout(() => {
            isFullscreenActive = false;
        }, 500);
    }
});

const productTabs = document.getElementById('product-tabs')
if (productTabs) {
    const editProductTabsParameters = () => {
        requestAnimationFrame(() => {
            productTabs.multiTab = checkResolution('cxs;txs')
            productTabs.allowTriggerClose = checkResolution('cxs;txs')

            if (!checkResolution('cxs;txs')) {
                productTabs.closeAllTabs();
                productTabs.openTab('tab-description');
            }
        })
    }

    rEvent.on('Window.resized', () => {
        if (!isFullscreenActive) {
            editProductTabsParameters();
        }
    });
    editProductTabsParameters()
}

rEvent.on('VariationValue.changed', function (changedVariationValue) {
    if (!changedVariationValue.custom_variation_qoute) {
        return
    }

    const isQuote = changedVariationValue.custom_quote

    if (isQuote) {
        $('.js-custom-forms').slideDown()
    } else {
        $('.js-custom-forms').slideUp()
    }

    $('.js-custom-forms input, .js-custom-forms textarea').each(function () {
        $(this).prop('disabled', !isQuote);
    });
})

/**
 *
 * @param {object} inputEl - input HTML element
 * @param {bool} checkContent - check input's content against predefined set of characters
 * @param {bool} affectsPrice - number of input's characters multiplies product's price
 * @param {number} maxlength - number of max input's characters
 * @param {bool} autoUppercase - set input's content to uppercase automatically
 */
window.handleChangedCustomFormInput = function (inputEl, checkContent, affectsPrice, maxlength, autoUppercase) {
    const $el = $(inputEl);
    const $variablePrice = $('.js-variable-price');
    const $variablePriceSmall = $('.js-variable-price__small');
    const $charCounter = $el.siblings('label').find('.js-form-character-count');

    if (maxlength && $el.val() && $el.val().split('').filter((c) => c !== ' ').length === maxlength) {
        $el.val($el.val().trim())

        if (!$el.hasClass('error')) {
            $el.addClass('error');
        }

        if (!$charCounter.hasClass('error')) {
            $charCounter.addClass('error');
        }

        if (window.lengthCheckTimeout !== undefined) {
            clearTimeout(window.lengthCheckTimeout);
        }
        window.lengthCheckTimeout = setTimeout(function () {
            $el.removeClass('error');
            $charCounter.removeClass('error');
        }, 1000);
    }

    // check input's max length and edit if necessary
    if (maxlength && $el.val() && $el.val().split('').filter((c) => c !== ' ').length > maxlength) {
        // replace actual value with correct value
        $el.val(
            $el.val().slice(
                0,
                maxlength + $el.val().split('').filter((c) => c === ' ').length
            )
        );

        if (!$el.hasClass('error')) {
            $el.addClass('error');
        }

        if (!$charCounter.hasClass('error')) {
            $charCounter.addClass('error');
        }

        if (window.lengthCheckTimeout !== undefined) {
            clearTimeout(window.lengthCheckTimeout);
        }
        window.lengthCheckTimeout = setTimeout(function () {
            $el.removeClass('error');
            $charCounter.removeClass('error');
        }, 1000);
    }

    // set input's content to uppercase
    if (autoUppercase) {
        $el.val($el.val().toUpperCase());
    }

    // check input value characters
    if (checkContent) {
        const tippyInstance = inputEl._tippy
        const invalidChars = $el.val()
            .split('')
            .filter(function (character) {
                return character !== ' ' && !window.customQuoteAllowedChars.toLowerCase().includes(character) && !window.customQuoteAllowedChars.toUpperCase().includes(character);
            });

        if (tippyInstance) {
            if (invalidChars.length) {
                tippyInstance.show()
            } else {
                tippyInstance.hide()
            }
        }

        if (invalidChars.length && !$el.hasClass('error')) {
            $el.toggleClass('error');

            if (window.inputCheckTimeout !== undefined) {
                clearTimeout(window.inputCheckTimeout);
            }
            window.inputCheckTimeout = setTimeout(function () { $el.toggleClass('error'); }, 1000);
        }

        $el.val($el.val()
            .split('')
            .filter(function (character) {
                return character === ' ' || window.customQuoteAllowedChars.toLowerCase().includes(character) || window.customQuoteAllowedChars.toUpperCase().includes(character);
            })
            .join('')
        );
    }

    // set variable price content according to input's content
    if (affectsPrice) {
        if (window.priceChangeTimeout != undefined) {
            clearTimeout(window.priceChangeTimeout);
        }

        const quantity = $el.val()
            .split('')
            .filter(function (character) {
                return character !== ' ';
            })
            .join('')
            .length;

        window.priceChangeTimeout = setTimeout(function () {
            const [priceVat, price] = [window.productData.price_vat * quantity, window.productData.price * quantity];

            $variablePrice.html(formatPrice(window.Eshop.options.pricesWithVat ? priceVat : price));
            $variablePriceSmall.html(formatPrice(window.Eshop.options.pricesWithVat ? price : priceVat));

            Cart.moduleData('.c-product-cart__buy [name="module_data"]', 'customSubquantity', quantity);
        }, 300);
    }

    // update character counter
    if (maxlength && $charCounter) {
        const remaining = maxlength - $el.val().split('').filter((c) => c !== ' ').length;
        $charCounter.html(localeTexts.charCounterText + ' ' + remaining.toString());
    }
}

dynamicEventListener('click', '.js-ratings-anchor', async () => {
    await new Promise((resolve) => requestAnimationFrame(resolve))

    scrollToEl(document.getElementById('tab-ratings'), checkResolution('cxs;txs') ? 60 : 110)
});

if ((new URLSearchParams(window.location.search)).get('rate-product')) {
    $('#new-rating').modal('show')
}

document.addEventListener('DOMContentLoaded', () => {
    new AsyncImageUpload({
        kendoInputSelector: '.js-rating-upload-kendo-input',
        valueInputSelector: '.js-rating-upload-value-input',
    })
})
